import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { ScimStatus } from '../../../../shared/types/routes/scim';

function fetchScimStatus(organizationId: number) {
  return get<ScimStatus>(`/api/organizations/${organizationId}/scim`);
}

export const getScimStatusQueryKey = (organizationId: number): QueryKey => ['organizations', organizationId, 'scim'];

/**
 * Hook to fetch whether SCIM provisioning is usable for an organization: `isEnabled` reflects the presence of
 * an active SCIM token, and `isSsoConfigured` whether a user provisioned over SCIM would have any way to sign
 * in. The endpoint 403s unless the per-org SCIM flag is on, so only call this behind that gate.
 *
 * @param organizationId - The organization ID
 * @returns Query result containing the organization's SCIM status
 */
export const useScimStatus = (organizationId: number) => {
  return useQuery<ScimStatus>({
    queryKey: getScimStatusQueryKey(organizationId),
    queryFn: () => fetchScimStatus(organizationId),
  });
};
